// extracted by mini-css-extract-plugin
export default {"MostList":"HotPlace_MostList__12ygU","List":"HotPlace_List__8vt2X","Container":"HotPlace_Container__90rLM"};